import React, { InputHTMLAttributes } from 'react';

import { DefaultProps, FormatProps } from './types';
import { useField } from './useField';

type TextAreaProps = DefaultProps & FormatProps & InputHTMLAttributes<unknown>;

export const RxTextArea: React.FC<TextAreaProps> = React.memo((props) => {
    const { rest, onInputChange, onInputBlur, ref } = useField(props);
    return <textarea {...rest} ref={ref as any} name={props.field} onChange={onInputChange} onBlur={onInputBlur} />;
});

export const TextArea = RxTextArea;
